import { createFileRoute } from '@tanstack/react-router';
import ManagerPortal from '../../components/portals/ManagerPortal';
import MarketingMaintenancePage from '../../components/manager/MarketingMaintenancePage';

export const Route = createFileRoute('/manager/marketing')({
  component: MarketingRoute,
});

function MarketingRoute() {
  return (
    <ManagerPortal>
      <MarketingMaintenancePage />
    </ManagerPortal>
  );
}
